(() => {
  if (window.islanderProductCardSwatchesInitialised) {
    return;
  }

  window.islanderProductCardSwatchesInitialised = true;

  const previewClass = 'islander-product-card--swatch-previewing';
  const observedQuickAddModals = new WeakSet();

  const resetQuickAddScrollPosition = (modal) => {
    const content = modal.querySelector('.quick-add-modal__content-info');

    if (!content) {
      return;
    }

    content.scrollTop = 0;
    content.scrollLeft = 0;
  };

  const observeQuickAddModal = (modal) => {
    if (!modal || observedQuickAddModals.has(modal)) {
      return;
    }

    observedQuickAddModals.add(modal);
    new MutationObserver(() => {
      resetQuickAddScrollPosition(modal);

      if (modal.hasAttribute('open')) {
        requestAnimationFrame(() => resetQuickAddScrollPosition(modal));
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  };

  const restorePreview = (swatch) => {
    const card = swatch.closest('.islander-product-card');
    const swatchRow = swatch.closest('.islander-product-card__swatches');
    const preview = card?.querySelector('.islander-product-card__image--swatch-preview');

    if (
      !card ||
      !preview ||
      card.querySelector('[data-swatch-image][aria-current="true"]') ||
      swatchRow?.matches(':hover') ||
      swatchRow?.contains(document.activeElement)
    ) {
      return;
    }

    if (preview.dataset.defaultSrc) {
      preview.src = preview.dataset.defaultSrc;
    }

    if (preview.dataset.defaultSrcset) {
      preview.setAttribute('srcset', preview.dataset.defaultSrcset);
    } else {
      preview.removeAttribute('srcset');
    }

    preview.alt = preview.dataset.defaultAlt || '';
    card.classList.remove(previewClass);
  };

  const showPreview = (swatch) => {
    const card = swatch.closest('.islander-product-card');
    const preview = card?.querySelector('.islander-product-card__image--swatch-preview');
    const imageSource = swatch.dataset.swatchImage;

    if (!card || !preview || !imageSource) {
      return;
    }

    if (!preview.dataset.defaultSrc) {
      preview.dataset.defaultSrc = preview.getAttribute('src') || '';
      preview.dataset.defaultSrcset = preview.getAttribute('srcset') || '';
      preview.dataset.defaultAlt = preview.alt || '';
    }

    preview.src = imageSource;
    preview.removeAttribute('srcset');
    preview.alt = swatch.dataset.swatchAlt || preview.dataset.defaultAlt || '';
    card.classList.add(previewClass);
  };

  const selectTouchSwatch = (swatch) => {
    const card = swatch.closest('.islander-product-card');
    const swatchRow = swatch.closest('.islander-product-card__swatches');
    const variantUrl = swatch.getAttribute('href');

    if (!card || !swatchRow || !variantUrl) {
      return;
    }

    swatchRow.querySelectorAll('[data-swatch-image][aria-current="true"]').forEach((selectedSwatch) => {
      selectedSwatch.removeAttribute('aria-current');
    });
    swatch.setAttribute('aria-current', 'true');

    card
      .querySelectorAll('.islander-product-card__media-link, .islander-product-card__title a')
      .forEach((productLink) => productLink.setAttribute('href', variantUrl));

    showPreview(swatch);
  };

  const getSwatch = (target) => {
    if (!(target instanceof Element)) {
      return null;
    }

    return target.closest('[data-swatch-image]');
  };

  document.addEventListener('pointerover', (event) => {
    const swatch = getSwatch(event.target);

    if (!swatch || (event.relatedTarget instanceof Node && swatch.contains(event.relatedTarget))) {
      return;
    }

    showPreview(swatch);
  });

  document.addEventListener('pointerout', (event) => {
    const swatch = getSwatch(event.target);

    if (!swatch || (event.relatedTarget instanceof Node && swatch.contains(event.relatedTarget))) {
      return;
    }

    restorePreview(swatch);
  });

  document.addEventListener('focusin', (event) => {
    const swatch = getSwatch(event.target);

    if (swatch) {
      showPreview(swatch);
    }
  });

  document.addEventListener('focusout', (event) => {
    const swatch = getSwatch(event.target);

    if (swatch) {
      queueMicrotask(() => restorePreview(swatch));
    }
  });

  document.addEventListener('click', (event) => {
    const quickAddOpener = event.target.closest?.(
      'modal-opener[data-modal^="#IslanderQuickAddModal-"]',
    );

    if (quickAddOpener) {
      observeQuickAddModal(document.querySelector(quickAddOpener.dataset.modal));
    }

    const swatch = getSwatch(event.target);
    const usesTouchSelection = window.matchMedia?.('(hover: none), (pointer: coarse)').matches;

    if (!swatch?.closest('.islander-home-bestsellers') || !usesTouchSelection) {
      return;
    }

    event.preventDefault();
    selectTouchSwatch(swatch);
  });

})();
